import watch1 from './Images/Watch1.png'
import watch2 from './Images/Watch2.png'
import watch3 from './Images/Watch3.png'
import watch4 from './Images/Watch4.png'
import watch5 from './Images/Watch5.png'
import watch6 from './Images/Watch6.png'
import watch7 from './Images/Watch7.png'
import watch8 from './Images/Watch8.png'
import watch9 from './Images/Watch9.png'
import watch10 from './Images/Watch10.png'
import watch11 from './Images/Watch11.png'
import watch12 from './Images/Watch12.png'
import watch13 from './Images/Watch13.png'
import watch14 from './Images/Watch14.png'
import watch15 from './Images/Watch15.png'
import watch16 from './Images/Watch16.png'
import watch17 from './Images/Watch17.png'
import watch18 from './Images/Watch18.png'
import watch19 from './Images/Watch19.png'
import watch20 from './Images/Watch20.png'
import watch21 from './Images/Watch21.png'



const WatchDet = [
    {
        id:1,
        name:"Vintage A158WA-1DF Black Digital Dial Silver Stainless Steel Band D011",
        brand:"Casio",
        price:1695,
        image:watch1,
        bandcolor:"Silver"
    },
    {
        id:2,
        name:"Women's Viva Trendsetter Rose Gold Metal Analog Watch-NS2642WM01",
        brand:"Titan Raga",
        price:3809,
        image:watch2,
        bandcolor:"Rose Gold"
    },
    {
        id:3,
        name:"Analog Day Date Functioning Stainless Steel Chain Watch for Men",
        brand:"TIMEWEAR",
        price:299,
        image:watch3,
        bandcolor:"Silver"
    },
    {
        id:4,
        name:"Leather Strap Analog Wrist Watch for Women",
        brand:"SWISSTONE",
        price:349,
        image:watch4,
        bandcolor:"Brown"
    },
    {
        id:5,
        name:"Analog Stainless Steel Silver Plated Women's Watch (Blue Dial Silver Colored Strap).",
        brand:"SWISSTONE",
        price:349,
        image:watch5,
        bandcolor:"Silver"
    },
    {
        id:6,
        name:"BY BENYAR Analogue Men's Watch",
        brand:"BY BENYAR",
        price:2151,
        image:watch6,
        bandcolor:"Silver"
    },
    {
        id:7,
        name:"Analog Stainless Steel Gold Plated Women's Watch (Black Dial Gold Colored Strap)",
        brand:"SWISSTONE",
        price:429,                                          
        image:watch7,
        bandcolor:"Gold"
    },
    {
        id:8,
        name:"Analog Slim Two Hands Leather Strap Watches for Men",
        brand:"TIMEWEAR",
        price:319,
        image:watch8,
        bandcolor:"Brown"
    },
    {
        id:9,
        name:"Men's Minimalist Zen Analog Blue Watch: Sleek Leather Strap with Contrast Hands",
        brand:"Titan",
        price:1596,
        image:watch9,
        bandcolor:"Blue"
    },
    {
        id:10,
        name:"Premium Round Diamond Silver Dial Analogue Watch for Women's and Girl's",
        brand:"Acnos®",
        price:299,
        image:watch10,
        bandcolor:"Multicolour"
    },
    {
        id:11,
        name:"Quartz Analog Blue Dial Stainless Steel Strap Watch for Guys",
        brand:"Fastrack ",
        price:1079,
        image:watch11,
        bandcolor:"Silver"
    },
    {
        id:12,
        name:"Analogue Women's Watch (Pink Dial Silver Colored Strap)",
        brand:"AUREX",
        price:419,
        image:watch12,
        bandcolor:"Silver"
    },
    {
        id:13,
        name:"Wear Your Look Quartz Analog Pink Dial Leather Strap Watch for Girls",
        brand:"Fastrack",
        price:1996,     
        image:watch13,
        bandcolor:"Pink"
    },
    {
        id:14,
        name:"Analog Business Casual Stainless Steel Decorative Subdials Watch for Men",
        brand:"LONGBO",
        price:791,
        image:watch14,
        bandcolor:"Silver"
    },
    {
        id:15,
        name:"Analog Champagne Dial Metal Strap Watch for Women",
        brand:"Sonata Quartz",
        price:1125,
        image:watch15,
        bandcolor:"Gold"
    },
    {
        id:16,
        name:"Analog Men's Watch (Gold Dial Colored Strap)",
        brand:"REDUX",
        price:399,
        image:watch16,
        bandcolor:"Gold"
    },
    {
        id:17,
        name:"Analog Boy's & Men's Watch (Blue Dial Blue Colored Strap)",
        brand:"REDUX",
        price:329,
        image:watch17,
        bandcolor:"Blue"
    },
    {
        id:18,
        name:"Women's Precision Simplicity Analog Watch: Grey Gradient Dial with Leather Strap",
        brand:"Titan",
        price:1796,
        image:watch18,
        bandcolor:"Brown"
    },
    {
        id:19,
        name:"Silicone Digital Men Watch (Black Dial Green Colored Strap), Green Band",
        brand:"V2A",
        price:691,
        image:watch19,
        bandcolor:"Green"
    },
    {
        id:20,
        name:"Women Stainless Steel Core Analog Purple Dial Watch",
        brand:"NIBOSI",
        price:1468,
        image:watch20,
        bandcolor:"Silver"
    },
    {
        id:21,
        name:"Vintage Series Digital Rose Gold Dial Women's Watch",
        brand:"Casio",
        price:5995,
        image:watch21,
        bandcolor:"Rose Gold"
    }
]
export default WatchDet